import { Popover } from '@mantine/core';

import { PopoverHead } from '../PopoverContent/PopoverHead';
import { SandboxContentControl } from '../SandboxContentControl/SandboxContentControl';

type ControllerPopoverTargetProps = {
  switchOpenedState: () => void;
};

export const PopoverControllerDropdown = ({ switchOpenedState }: ControllerPopoverTargetProps) => (
  <Popover.Dropdown
    p={0}
    styles={{
      dropdown: {
        height: 550,
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 392,
        width: '100%',
        boxShadow: 'none',
        borderRadius: 14,
      },
    }}
  >
    <PopoverHead switchOpenedState={switchOpenedState} />
    <SandboxContentControl />
  </Popover.Dropdown>
);
